// extracted by mini-css-extract-plugin
export default {"container":"hM-z","topReviewHeading":"iM-z","criticalReview":"jM-z","favorableReview":"kM-z","vsSeparator":"lM-z"};